import {
  Container,
  BackgroundImage,
  Card,
  Header,
  Avatar,
  Name,
  Description,
  Section,
  SectionTitle,
  Paragraph,
  SocialIcons,
  ContentWrapper,
  VideoImage,
} from "./PressKitPreviewStyles";

import avatarDefault from "../../img/logged/avatar.png";
import photo1Default from "../../img/logged/photo1.png";
import photo2Default from "../../img/logged/photo2.png";
import spotifyIcon from "../../img/logged/spotify.png";
import soundcloudIcon from "../../img/logged/soundcloud.png";
import instaIcon from "../../img/logged/insta.png";
import youtubeIcon from "../../img/logged/youtube.png";
import videoyoutube from "../../img/logged/videoyoutube.png";

import TrackCarousel from "../trackCarousel/TrackCarousel";
import { PressKitData } from "../../types/componentsConstructors";

interface Props {
  data?: PressKitData;
}

const mockDescription = `Criando momentos únicos através da música.

Producer | DJ | Tech-House / House Music

Com uma sonoridade marcada por batidas pulsantes e atmosferas imersivas, JO é um produtor e DJ que transforma emoções em música.
Com influência de clubes underground e festivais internacionais, seu som conecta o presente ao futuro da pista.
Cada set é pensado para criar uma experiência única, intensa, vibrante e memorável.`;

const mockEvents = [
  "Conection – 05/07/2025",
  "High Stage Festival – 16/08/2025",
  "Warung Tour – 25/10/2025",
];

const mockVideoUrl = videoyoutube;

const mockSocialLinks = {
  spotify: "#",
  soundcloud: "#",
  instagram: "#",
  youtube: "#",
};

const PressKitPreview = ({ data }: Props) => {
  const {
    artistName = "DJ Jhow",
    description = mockDescription,
    avatar = avatarDefault,
    background1 = photo1Default,
    background2 = photo2Default,
    tracks,
    events = mockEvents,
    videoUrl = mockVideoUrl,
    socialLinks = mockSocialLinks,
  } = data || {};

  return (
    <Container>
      <Card>
        <ContentWrapper>
          <Header>
            <Avatar src={avatar} />
            <Name>{artistName}</Name>
            <Description>{description}</Description>
          </Header>

          <Section>
            <SectionTitle>Músicas e Sets</SectionTitle>
            <TrackCarousel tracks={tracks} />
          </Section>

          {events.length > 0 && (
            <Section>
              <SectionTitle>Eventos</SectionTitle>
              {events.map((event, index) => (
                <Paragraph key={index}>{event}</Paragraph>
              ))}
            </Section>
          )}

          {videoUrl && (
            <Section>
              <VideoImage src={videoUrl} alt="Vídeo promocional" />
            </Section>
          )}

          <SocialIcons>
            {socialLinks.spotify && <img src={spotifyIcon} alt="Spotify" />}
            {socialLinks.soundcloud && (
              <img src={soundcloudIcon} alt="SoundCloud" />
            )}
            {socialLinks.instagram && <img src={instaIcon} alt="Instagram" />}
            {socialLinks.youtube && <img src={youtubeIcon} alt="YouTube" />}
          </SocialIcons>
        </ContentWrapper>

        <BackgroundImage
          src={background1}
          $top="40px"
          $topDesktop="200px"
          $left="-10%"
          $opacity="0.25"
          $blur="2px"
          $widthMobile="190px"
          $widthDesktop="500px"
        />

        <BackgroundImage
          src={background2}
          $bottom="60px"
          $right="-10%"
          $bottomDesktop="320px"
          $widthMobile="210px"
          $widthDesktop="550px"
          $opacity="0.55"
          $blur="1px"
        />
      </Card>
    </Container>
  );
};

export default PressKitPreview;
